import { render, staticRenderFns } from "./createFeeByComboList.vue?vue&type=template&id=5c3906d3&scoped=true"
import script from "./createFeeByComboList.vue?vue&type=script&lang=js"
export * from "./createFeeByComboList.vue?vue&type=script&lang=js"
import style0 from "./createFeeByComboList.vue?vue&type=style&index=0&id=5c3906d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3906d3",
  null
  
)

export default component.exports